<script lang="ts" setup>
import AuftragBearbeiten from "../actions/AuftragBearbeiten.vue";
import BegleitfahrtBearbeiten from "../actions/BegleitfahrtBearbeiten.vue";
import BegleitfahrtEntfernen from "../actions/BegleitfahrtEntfernen.vue";
import DispositionsAuftragBegleitfahrt from "./DispositionsAuftragBegleitfahrt.vue";
import AuftragEntfernen from "../actions/AuftragEntfernen.vue";
import AuftragKopieren from "../actions/AuftragKopieren.vue";
import DispositionFahrerListe from "./DispositionFahrerListe.vue";
import { IAuftrag } from "../api/useDispositionsplan";
import DispositionsAuftragTop from "./DispositionsAuftragTop.vue";
import DispositionsAuftragFahrzeug from "./DispositionsAuftragFahrzeug.vue";

defineProps<{ auftrag: IAuftrag; query: () => void }>();
</script>

<template>
  <div class="relative whitespace-normal group auftrag">
    <div
      class="absolute top-0 right-0 px-4 py-2 space-x-5 transition bg-white rounded-bl shadow opacity-0 group-hover:opacity-100 print:shadow-none"
    >
      <AuftragBearbeiten
        :bemerkung="auftrag.bemerkung"
        :kunde-id="auftrag.kunde.id"
        :auftrag-id="auftrag.id"
        :von="auftrag.abholung.name"
        :nach="auftrag.anlieferung.name"
        :mehrwertsteuerpflichtig="auftrag.mehrwertsteuerpflichtig"
        :abholdatum="auftrag.abholung.datum as string"
        :anlieferdatum="auftrag.anlieferung.datum"
        :fahrer="auftrag.fahrzeug.fahrer"
        :fahrzeugtyp="auftrag.fahrzeug.fahrzeugtyp"
        :abrechnungsnummer="auftrag.abrechnungsnummer"
        :kennzeichen="auftrag.fahrzeug.kennzeichen"
        :fahrgestellnummer="auftrag.fahrzeug.fahrgestellnummer"
        :query="query"
      />
      <AuftragKopieren :query="query" :auftrag="auftrag" />
      <AuftragEntfernen
        :auftrag-id="auftrag.id"
        :auftrag-text="
          auftrag.abholung.name + ' -> ' + auftrag.anlieferung.name
        "
        :query="query"
      />
    </div>
    <div class="block w-full px-4 py-2 bg-white shadow-md print:shadow-none">
      <DispositionsAuftragTop
        :abholung="auftrag.abholung"
        :anlieferung="auftrag.anlieferung"
      />
      <DispositionsAuftragFahrzeug
        :fahrzeug="auftrag.fahrzeug"
        :abrechnungsnummer="auftrag.abrechnungsnummer"
      />
      <div class="">
        <hr class="h-px bg-gray-300 border-0" />
        <div class="py-1 text-sm text-gray-800 px-0.5">
          <DispositionFahrerListe :fahrer="auftrag.fahrzeug.fahrer" />
        </div>
      </div>
      <div v-if="auftrag.begleitfahrten.length" class="">
        <hr class="h-px bg-gray-300 border-0" />
        <div class="py-0.5 space-y-0.5 text-sm">
          <div
            v-for="(begleitfahrt, index) in auftrag.begleitfahrten"
            :key="index"
          >
            <div
              class="relative flex leading-tight px-0.5 py-[0.0625rem]"
              :style="{
                color: begleitfahrt.typ.schriftfarbe,
                backgroundColor: begleitfahrt.typ.hintergrundfarbe,
              }"
            >
              <DispositionsAuftragBegleitfahrt
                :begleitfahrt="begleitfahrt"
                :auftrag-von-datum="auftrag.abholung.datum"
              />
              <div
                class="absolute flex items-center px-4 space-x-5 transition bg-white rounded-l shadow opacity-0 top-0.5 bottom-0.5 border-gray-50 -right-4 group-hover:opacity-100"
              >
                <BegleitfahrtBearbeiten
                  :query="query"
                  :auftrag-id="auftrag.id"
                  :begleitfahrt-id="begleitfahrt.id"
                  :von="begleitfahrt.von.name"
                  :nach="begleitfahrt.nach.name"
                  :typ-id="begleitfahrt.typ.id"
                  :kennzeichen="begleitfahrt.kennzeichen"
                  :abholdatum="begleitfahrt.von.datum as string"
                  :anlieferdatum="begleitfahrt.nach.datum"
                  :fahrer="begleitfahrt.fahrer"
                  :mehrwertsteuerpflichtig="
                    begleitfahrt.mehrwertsteuerpflichtig
                  "
                />
                <BegleitfahrtEntfernen
                  :query="query"
                  :auftrag-id="auftrag.id"
                  :begleitfahrt-id="begleitfahrt.id"
                  :begleitfahrt-beschreibung="
                    begleitfahrt.von.name +
                    ' -> ' +
                    begleitfahrt.nach.name +
                    ' (' +
                    begleitfahrt.fahrer_namen.join(', ') +
                    ')'
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="auftrag.bemerkung" class="text-sm text-gray-800">
        <hr class="h-px bg-gray-300 border-0" />
        <div class="px-0.5 py-0.5">
          {{ auftrag.bemerkung.split("\n").slice(0, 1).join("") }}
        </div>
      </div>
    </div>
  </div>
</template>
